export type WorldSource = { label: string; path?: string };

export type WorldData = {
  schemaVersion: number;
  meta: { title: string; updatedAt: string; description?: string };
  guilds: Array<{ id: string; name: string; summary: string; status: string; sources: WorldSource[] }>;
  fragments: Array<{
    id: string;
    name: string | null;
    bearerId: string;
    description: string;
    status: string;
    sources: WorldSource[];
  }>;
  locations: Array<{
    id: string;
    name: string;
    kind: string;
    description: string;
    status: string;
    sources: WorldSource[];
  }>;
  classes: Array<{ id: string; name: string; description: string; status: string; sources: WorldSource[] }>;
  rankingGoals: Array<{
    characterId: string;
    bookId: string;
    rank: number;
    kind: "goal";
    label: string;
    status: string;
    sources: WorldSource[];
  }>;
  plannedBooks: Array<{
    id: string;
    number: number;
    title: string;
    writingStatus: string;
    status: string;
    sources: WorldSource[];
  }>;
  arcs: Array<{
    id: string;
    title: string;
    summary: string;
    state: string;
    characterIds: string[];
    status: string;
    sources: WorldSource[];
  }>;
  lore: Array<{ id: string; title: string; body: string; status: string; sources: WorldSource[] }>;
  tones: Record<string, string>;
};

export const EMPTY_WORLD: WorldData = {
  schemaVersion: 1,
  meta: { title: "Monde", updatedAt: new Date(0).toISOString() },
  guilds: [],
  fragments: [],
  locations: [],
  classes: [],
  rankingGoals: [],
  plannedBooks: [],
  arcs: [],
  lore: [],
  tones: {},
};
